import { request } from '~/agent';

export const uploadFile = (file, params, config) => {
    return request.upload('files', null, file, params, config);
};

export const uploadImage = (file, params, config) => {
    return request.upload('files/images', null, file, params, config);
};

export const deleteFile = id => {
    return request.del(`files/${id}`);
};

export const deleteFileAttachment = id => {
    return request.del(`files/attachments/${id}`);
};
